// Generated by ReScript, PLEASE EDIT WITH CARE

import * as InsurancePlanContentMapper from "./content-mapper/InsurancePlanContentMapper.bs.js";

function execute(language, category, geo_region) {
  switch (language) {
    case /* English */0 :
        return InsurancePlanContentMapper.English.getContent(category, language, geo_region);
    case /* Hindi */1 :
        return InsurancePlanContentMapper.Hindi.getContent(category, language, geo_region);
    case /* Kannada */2 :
        return InsurancePlanContentMapper.Kannada.getContent(category, language, geo_region);
    case /* Tamil */3 :
        return InsurancePlanContentMapper.Tamil.getContent(category, language, geo_region);
    case /* Telugu */4 :
        return InsurancePlanContentMapper.Telugu.getContent(category, language, geo_region);
    case /* Marathi */5 :
        return InsurancePlanContentMapper.Marathi.getContent(category, language, geo_region);
    case /* Malayalam */6 :
        return InsurancePlanContentMapper.Malayalam.getContent(category, language, geo_region);
    case /* Bangla */7 :
        throw {
              RE_EXN_ID: "Match_failure",
              _1: [
                "InsuranceContentManager.res",
                5,
                4
              ],
              Error: new Error()
            };
    
  }
}

var InsurancePlanContentManager = {
  execute: execute
};

export {
  InsurancePlanContentManager ,
  
}
/* InsurancePlanContentMapper Not a pure module */
